<i (click)="dismiss.emit()" ui-icon uiType="close-big" uiSize="large"></i>

<gh-indicator [(ghValue)]="indicators.loading" [ghMessage]="'loading' | localize"></gh-indicator>

<ng-container *ngIf="!indicators.loading && hasManageTasksPermissions">
  <h3>{{ "create_task" | localize }}</h3>
  <p>{{ "all_required_fields_are_marked_with_an_asterisk" | localize }}</p>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" ui-form>
    <ui-form-item ui-row uiGutter="8">
      <ui-form-label uiFlex="176px" uiFor="name" uiRequired>{{ "name" | localize }}</ui-form-label>
      <ui-form-control>
        <ui-input-text-field
          [value]="formName.value"
          [disabled]="!hasManageTasksPermissions"
          [focusMe]="true"
          [required]="true"
          [uiPlaceholder]="'enter_task_name' | localize"
          (keydown)="onKeydown($event, 'name')"
          formControlName="name"
          uiId="name"
          data-test-id="task-modal-task-title"></ui-input-text-field>
      </ui-form-control>
    </ui-form-item>

    <ui-form-item ui-row uiGutter="8">
      <ui-form-label uiFlex="176px" uiFor="owner" uiRequired>{{ "owner_cap" | localize }}</ui-form-label>
      <gh-indicator [(ghValue)]="indicators.loadingAssignee" [ghMessage]="'loading' | localize"></gh-indicator>
      <ui-form-control *ngIf="!indicators.loadingAssignee">
        <!-- TODO: https://quantive-inc.atlassian.net/browse/GVS-41987 -->
        <!-- [assignPermissions]="'user'" -->
        <!-- [onlyOneId]="true" -->
        <people-selector
          [selectedIds]="[task.ownerId]"
          [atLeastOneValue]="true"
          [disabled]="!hasManageTasksPermissions"
          (selectionChange)="updateTaskOwner($event)"
          uiId="task-owner"
          data-test-id="task-view-owner-selector">
        </people-selector>
      </ui-form-control>
    </ui-form-item>

    <ui-form-item ui-row uiGutter="8">
      <ui-form-label uiFlex="176px" uiFor="status" uiRequired>{{ "status_cap" | localize }}</ui-form-label>
      <ui-form-control>
        <ui-select [uiOptionHeightPx]="36" [uiSize]="'large'" [uiDisabled]="!hasManageTasksPermissions" formControlName="status" uiId="status" data-test-id="task-status">
          <ui-option [uiValue]="statuses.toDo" [uiLabel]="statuses.toDo | localize"></ui-option>
          <ui-option [uiValue]="statuses.inProgress" [uiLabel]="statuses.inProgress | localize"></ui-option>
          <ui-option [uiValue]="statuses.done" [uiLabel]="statuses.done | localize"></ui-option>
        </ui-select>
      </ui-form-control>
    </ui-form-item>

    <ui-form-item ui-row uiGutter="8">
      <ui-form-label uiFlex="176px" uiFor="due-date">{{ "due_date_cap" | localize }}</ui-form-label>
      <ui-form-control>
        <ui-date-picker [uiDisabled]="!hasManageTasksPermissions" [uiAllowClear]="true" (keydown)="onKeydown($event, 'dueDate')" uiId="due-date" formControlName="dueDate"></ui-date-picker>
      </ui-form-control>
    </ui-form-item>

    <ui-form-item ui-row uiGutter="8">
      <ui-form-label uiFlex="176px" uiFor="linked-to">{{ "linked_to_cap" | localize }}</ui-form-label>
      <ui-form-control>
        <parent-selector
          [a11yRequired]="true"
          [a11yLabelledby]="'linked-to'"
          [disabled]="!hasManageTasksPermissions"
          [placeholder]="'select_parent_objective_or_kr'"
          [suggestionTarget]="task.name"
          [goalIdToExclude]="task.id"
          [ownerIds]="[task.ownerId]"
          (selectionChange)="updateTaskParent($event)"
          (keydown)="onKeydown($event, 'linkedTo')"
          uiId="linked-to"></parent-selector>

        <!-- TODO: https://quantive-inc.atlassian.net/browse/GVS-41990 -->
        <!--[selected-parent-item]=""
          [session-ids]=""
          [current-goal-id]="task.id"
          [current-goal]="task" -->
      </ui-form-control>
    </ui-form-item>

    <ui-form-item ui-row uiGutter="8">
      <ui-form-label uiFlex="176px" uiFor="task-description">{{ "description_cap" | localize }}</ui-form-label>
      <ui-form-control>
        <rich-text-editor
          [(text)]="task.description"
          [placeholder]="'add_description' | localize"
          [withoutGifs]="true"
          [hidePostButton]="true"
          [readOnly]="!hasManageTasksPermissions"
          uiId="task-description"
          data-test-id="taskDescription"></rich-text-editor>
      </ui-form-control>
    </ui-form-item>

    <editable-custom-fields
      [customFieldValues]="task.customFields"
      [disableRequired]="!hasManageTasksPermissions"
      (fieldsChange)="updateCustomFields($event)"
      targetType="task"
      formName="create-task-form"></editable-custom-fields>

    <ng-container *ngIf="!indicators.creating">
      <button class="sp-mr-12" [disabled]="!form.valid" ui-button type="submit" data-test-id="create-task" uiSize="large" uiType="primary" uiShape="round">
        {{ "create_task" | localize }}
      </button>

      <button (click)="dismiss.emit()" ui-button uiShape="round" uiType="link" uiSize="large" data-test-id="task-close-modal-button">{{ "cancel" | localize }}</button>
    </ng-container>
  </form>

  <gh-indicator [(ghValue)]="indicators.creating" [ghMessage]="'creating' | localize"></gh-indicator>
</ng-container>
